import "./Home.css";
import "./Home.css";
import ball3 from "./HomeImage/ball3.png";
import dort from "./HomeImage/dort.png";
import bray from "./HomeImage/bray.png";
import breaknews from "./HomeImage/breaknews.jpg";
import match from "./HomeImage/match.png";
import ro from "./HomeImage/ro.png";
import double from "./HomeImage/double.png";
import "../../index.css";
import { Link } from "react-router-dom";
import { useEffect, useMemo, useState, useRef } from "react";
import { getColorSync } from "colorthief";
import Skeleton from "../../components/Skeleton";
import { Helmet } from "react-helmet-async";
import AddSection from "../../components/AddSection/AddSection";
import blackArrow from "./../../images/arrow.png";
import whiteArrow from "./../../images/white-arrow.png";
import logo from "../../components/images/logo.png";
import worldCup from "./HomeImage/worldcup.png";

const API_CACHE_TTL = 30 * 60 * 1000;
const IMAGE_CACHE_NAME = "fada-home-images-v1";

const getCachedJson = (cacheKey) => {
  if (typeof window === "undefined") return null;

  try {
    const cachedData = localStorage.getItem(cacheKey);
    return cachedData ? JSON.parse(cachedData) : null;
  } catch (err) {
    console.error("Error reading cached JSON:", err);
    return null;
  }
};

const setCachedJson = (cacheKey, data) => {
  if (typeof window === "undefined") return;

  try {
    localStorage.setItem(cacheKey, JSON.stringify(data));
  } catch (err) {
    console.error("Error storing cached JSON:", err);
  }
};

const shouldUseCachedData = (cachedTime) => {
  if (!cachedTime || Number.isNaN(Number(cachedTime))) return false;
  return Date.now() - Number(cachedTime) < API_CACHE_TTL;
};

const buildFetchOptions = () => ({ cache: "force-cache" });

const isImageUrl = (value) =>
  typeof value === "string" &&
  /^(https?:)?\/\//i.test(value) &&
  /\.(jpg|jpeg|png|gif|webp|svg|avif)(\?.*)?$/i.test(value);

const collectImageUrls = (value, urls = new Set()) => {
  if (!value) return urls;

  if (Array.isArray(value)) {
    value.forEach((item) => collectImageUrls(item, urls));
    return urls;
  }

  if (typeof value === "object") {
    Object.values(value).forEach((childValue) => {
      if (typeof childValue === "string" && isImageUrl(childValue)) {
        urls.add(childValue);
      } else {
        collectImageUrls(childValue, urls);
      }
    });
  }

  return urls;
};

const cacheImagesFromPayload = async (payload) => {
  if (typeof window === "undefined" || !("caches" in window)) return;

  try {
    const imageUrls = [...collectImageUrls(payload)];

    await Promise.all(
      imageUrls.map(async (url) => {
        const cache = await caches.open(IMAGE_CACHE_NAME);
        const cachedResponse = await cache.match(url);

        if (cachedResponse) return;

        const response = await fetch(url, buildFetchOptions());

        if (response.ok) {
          await cache.put(url, response.clone());
        }
      }),
    );
  } catch (err) {
    console.error("Error pre-caching images:", err);
  }
};

const Home = ({ dark, setDark, MyBaseUrl }) => {
  const tabsRef = useRef(null);

  const scrollTabsLeft = () => {
    if (tabsRef.current) {
      tabsRef.current.scrollBy({
        left: -100,
        behavior: "smooth",
      });
    }
  };

  const scrollTabsRight = () => {
    if (tabsRef.current) {
      tabsRef.current.scrollBy({
        left: 100,
        behavior: "smooth",
      });
    }
  };

  const [featuredPosts, setFeaturedPosts] = useState([]);
  const [trendingTeams, setTrendingTeams] = useState([]);
  const [latestVideos, setLatestVideos] = useState([]);
  const [featuredMatches, setFeaturedMatches] = useState([]);
  const [popularNews, setPopularNews] = useState([]);
  const [breakingnews, setBreakingNews] = useState([]);
  const [trendingPlayers, setTrendingPlayers] = useState([]);
  const [categoryPosts, setCategoryPosts] = useState([]);
  const [mostTalkedAbout, setMostTalkedAbout] = useState([]);

  const [loadingMostTalkedAbout, setLoadingMostTalkedAbout] = useState(true);
  const [loadingHome, setLoadingHome] = useState(true);
  const [loadingVideos, setLoadingVideos] = useState(true);
  const [loadingMatches, setLoadingMatches] = useState(true);
  const [loadingNews, setLoadingNews] = useState(true);
  const [loadingPlayers, setLoadingPlayers] = useState(true);
  const [loadingPosts, setLoadingPosts] = useState(true);
  const [loadingBreakingNews, setLoadingBreakingNews] = useState(true);
  const [loadingFeaturedMatches, setLoadingFeaturedMatches] = useState(true);
  const [competitionPosts, setCompetitionPosts] = useState([]);
  const [loadingCompetitionPosts, setLoadingCompetitionPosts] = useState(true);

  const [matches, setMatches] = useState([]);

  const formatLocalDate = (date) => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");

    return `${year}-${month}-${day}`;
  };

  const [selectedDate, setSelectedDate] = useState(formatLocalDate(new Date()));

  const [selectedLeague, setSelectedLeague] = useState("all");

  const [competition, setCompetitions] = useState([]);
  const [competitionsError, setCompetitionsError] = useState();
  const [competitionloading, setCompetitionsLoading] = useState();
  const [latestPosts, setLatestPosts] = useState([]);
  const [loadingLatestPosts, setLoadingLatestPosts] = useState(true);

  const [page, setPage] = useState(1);
  const [lastPage, setLastPage] = useState(null);
  const [loadingMore, setLoadingMore] = useState(false);

  const [selectedLeagueId, setSelectedLeagueId] = useState(1);

  const [Loading, setLoading] = useState();
  const [error, setError] = useState();
  const [leagueInfo, setLeagueInfo] = useState();
  const [rank, setRank] = useState();
  const [standings, setStandings] = useState();

  const [homeColors, setHomeColors] = useState({});
  const [awayColors, setAwayColors] = useState({});

  // Team brand color mapping (predefined colors instead of extracting)
  const teamColorMap = {
    1: "#003d7a", // team 1
    2: "#003da5", // team 2
    3: "#0066cc", // team 3
    4: "#1e3c72", // team 4
    5: "#c60c30", // team 5 (red)
    6: "#fdb913", // team 6 (gold)
    7: "#f23716", // team 7 (orange)
    8: "#003399", // team 8
    9: "#2d5016", // team 9 (green)
    10: "#e8102e", // team 10 (red)
  };

  // Get color for team by ID with fallback
  const getTeamColor = (teamId) => {
    if (teamColorMap[teamId]) return teamColorMap[teamId];
    // Generate consistent color from team ID
    const hue = (teamId * 137.5) % 360; // Golden angle for unique colors
    return `hsl(${hue}, 70%, 50%)`;
  };

  const createSlug = (homeTeam, awayTeam) => {
    return [homeTeam, awayTeam]
      .filter(Boolean)
      .join(" ")
      .toLowerCase()
      .replace(/[^a-z0-9\s-]/g, "")
      .trim()
      .replace(/\s+/g, "-");
  };

  const extractColor = (img, type, key) => {
    try {
      // Verify image is loaded and accessible
      if (!img || img.complete === false) {
        console.log("Image not fully loaded yet");
        return;
      }

      const result = getColorSync(img);

      if (!result || result.length < 3) {
        console.log("Invalid color result");
        return;
      }

      const rgb = `rgb(${result[0]}, ${result[1]}, ${result[2]})`;
      console.log(`Extracted ${type} color:`, rgb);

      if (type === "home") {
        setHomeColors((prev) => ({
          ...prev,
          [key]: rgb,
        }));
      } else if (type === "away") {
        setAwayColors((prev) => ({
          ...prev,
          [key]: rgb,
        }));
      }
    } catch (err) {
      console.error("Color extraction failed:", err.message);
      // Fallback to random color on error
      const fallbackColor = `hsl(${Math.random() * 360}, 70%, 50%)`;

      if (type === "home") {
        setHomeColors((prev) => ({
          ...prev,
          [key]: fallbackColor,
        }));
      } else if (type === "away") {
        setAwayColors((prev) => ({
          ...prev,
          [key]: fallbackColor,
        }));
      }
    }
  };

  useEffect(() => {
    const fetchCompetitions = async () => {
      try {
        const response = await fetch(`${MyBaseUrl}/competitions`);

        if (!response.ok) throw new Error("Failed to fetch competitions");

        const result = await response.json();

        if (result.status === "success") {
          setCompetitions(result.data);
        }
      } catch (err) {
        setCompetitionsError(err.message);
      } finally {
        setCompetitionsLoading(false);
      }
    };

    fetchCompetitions();
  }, []);

  useEffect(() => {
    if (competition?.length > 0 && !selectedLeagueId) {
      const worldCupLeague = competition.find((comp) => comp?.league?.id === 1);

      setSelectedLeagueId(
        worldCupLeague?.league?.id || competition[0]?.league?.id,
      );
    }
  }, [competition, selectedLeagueId]);

  useEffect(() => {
    if (!selectedLeagueId) return;

    const fetchStandings = async () => {
      try {
        setLoading(true);
        setError(null);

        const response = await fetch(
          `${MyBaseUrl}/competitions/${selectedLeagueId}/standings`,
        );

        if (!response.ok) {
          throw new Error("Failed to fetch standings");
        }

        const data = await response.json();

        const leagueData = data?.data?.[0]?.league || null;
        setLeagueInfo(leagueData);

        const extracted = leagueData?.standings?.[0] || [];

        setStandings(extracted);
        setRank(leagueData);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchStandings();
  }, [selectedLeagueId]);

  const getBorderColor = (description) => {
    if (!description) return "4px solid transparent";

    const text = description.toLowerCase();

    if (text.includes("champions")) return "4px solid #16a34a";
    if (text.includes("europa")) return "4px solid #f97316";
    if (text.includes("conference")) return "4px solid #3b82f6";
    if (text.includes("promotion")) return "4px solid #16a34a";
    if (text.includes("relegation")) return "4px solid #ef4444";
    if (text.includes("ranking")) return "4px solid #a1a1aa";

    return "4px solid transparent";
  };

  const getRankColor = (index, dark) => {
    const colors = [
      "#533",
      "rgba(47, 117, 0, 1)",
      "rgba(47, 25, 129, 1)",
      "rgba(129, 2, 119, 0.89)",
      "rgba(133, 124, 6, 1)",
      "rgba(3, 129, 129, 1)",
    ];

    return dark
      ? {
          backgroundColor: "#8d8d8dff",
          color: colors[index] || "#333",
        }
      : {
          backgroundColor: "#3451C7",
          color: "#161819",
        };
  };

  useEffect(() => {
    const fetchHome = async () => {
      try {
        setLoadingHome(true);
        setLoadingVideos(true);
        setLoadingMatches(true);
        setLoadingNews(true);
        setLoadingPlayers(true);
        setLoadingPosts(true);
        setLoadingBreakingNews(true);
        setLoadingFeaturedMatches(true);

        const CACHE_KEY = "home_cache";
        const CACHE_TIME_KEY = "home_cache_time";

        const cachedData = getCachedJson(CACHE_KEY);
        const cachedTime = localStorage.getItem(CACHE_TIME_KEY);

        if (cachedData && shouldUseCachedData(cachedTime)) {
          const data = cachedData;

          setFeaturedPosts(data?.data?.featured_posts || []);
          setTrendingTeams(data?.data?.trending_teams || []);
          setLatestVideos(data?.data?.latest_videos || []);
          setPopularNews(data?.data?.most_read_news || []);
          setBreakingNews(data?.data?.breaking_news || []);
          setTrendingPlayers(data?.data?.trendy_players || []);
          setCategoryPosts(data?.data?.category_sections || []);

          const live = data?.data?.live_matches || [];
          const upcoming = data?.data?.upcoming_matches || [];
          setMatches([...live, ...upcoming]);

          setLoadingHome(false);
          setLoadingVideos(false);
          setLoadingMatches(false);
          setLoadingNews(false);
          setLoadingPlayers(false);
          setLoadingPosts(false);
          setLoadingBreakingNews(false);

          return;
        }

        const res = await fetch(`${MyBaseUrl}/home`, buildFetchOptions());

        if (!res.ok) {
          throw new Error("Failed to fetch home data");
        }

        const data = await res.json();

        setCachedJson(CACHE_KEY, data);
        localStorage.setItem(CACHE_TIME_KEY, Date.now().toString());
        await cacheImagesFromPayload(data?.data || data);

        setFeaturedPosts(data?.data?.featured_posts || []);
        setTrendingTeams(data?.data?.trending_teams || []);
        setLatestVideos(data?.data?.latest_videos || []);
        // setFeaturedMatches(data?.data?.featured_matches || []);
        setPopularNews(data?.data?.most_read_news || []);
        setBreakingNews(data?.data?.breaking_news || []);
        setTrendingPlayers(data?.data?.trendy_players || []);
        setCategoryPosts(data?.data?.category_sections || []);

        const live = data?.data?.live_matches || [];
        const upcoming = data?.data?.upcoming_matches || [];
        setMatches([...live, ...upcoming]);
      } catch (err) {
        console.error("Error fetching home data:", err);
      } finally {
        setLoadingHome(false);
        setLoadingVideos(false);
        setLoadingMatches(false);
        setLoadingNews(false);
        setLoadingPlayers(false);
        setLoadingPosts(false);
      }
    };

    fetchHome();
  }, []);

  useEffect(() => {
    const fetchFeaturedMatches = async () => {
      try {
        setLoadingFeaturedMatches(true);

        const res = await fetch(
          `${MyBaseUrl}/matches/featured?date=${selectedDate}`,
          buildFetchOptions(),
        );

        const data = await res.json();

        setFeaturedMatches(data?.data || []);
      } catch (err) {
        console.error("Error fetching featured matches:", err);
      } finally {
        setLoadingFeaturedMatches(false);
      }
    };

    fetchFeaturedMatches();
  }, [selectedDate]);

  useEffect(() => {
    const fetchLatestPosts = async () => {
      try {
        setLoadingLatestPosts(true);

        const res = await fetch(
          `${MyBaseUrl}/posts/latest`,
          buildFetchOptions(),
        );
        const data = await res.json();

        setLatestPosts(data?.data?.data || []);
      } catch (err) {
        console.error("Error fetching latest posts:", err);
      } finally {
        setLoadingLatestPosts(false);
      }
    };

    fetchLatestPosts();
  }, []);

  useEffect(() => {
    const fetchCompetitionPosts = async () => {
      const compIds = [1, 2, 4, 39, 140, 135, 307];

      try {
        setLoadingCompetitionPosts(true);

        const responses = await Promise.all(
          compIds.map((id) =>
            fetch(
              `${MyBaseUrl}/competitions/${id}/news`,
              buildFetchOptions(),
            ).then((res) => res.json()),
          ),
        );

        const allPosts = responses.flatMap((response) => {
          const competition = response?.data?.competition;

          return (response?.data?.data || []).map((post) => ({
            ...post,
            competition,
          }));
        });

        setCompetitionPosts(allPosts);
      } catch (err) {
        console.error("Error fetching competition posts:", err);
      } finally {
        setLoadingCompetitionPosts(false);
      }
    };

    fetchCompetitionPosts();
  }, []);

  useEffect(() => {
    const TalkedAboutPosts = async () => {
      try {
        setLoadingMostTalkedAbout(true);

        const CACHE_KEY = "most_talked_about_cache";
        const CACHE_TIME_KEY = "most_talked_about_cache_time";
        const THIRTY_MINUTES = 30 * 60 * 1000;

        const cachedData = localStorage.getItem(CACHE_KEY);
        const cachedTime = localStorage.getItem(CACHE_TIME_KEY);

        if (cachedData && cachedTime) {
          const now = new Date().getTime();

          if (now - cachedTime < THIRTY_MINUTES) {
            const parsed = JSON.parse(cachedData);

            setMostTalkedAbout(parsed?.data?.data || []);
            setLoadingMostTalkedAbout(false);
            return;
          }
        }

        const res = await fetch(
          `${MyBaseUrl}/posts/most-talked-about`,
          buildFetchOptions(),
        );

        const data = await res.json();

        localStorage.setItem(CACHE_KEY, JSON.stringify(data));
        localStorage.setItem(CACHE_TIME_KEY, new Date().getTime());

        setMostTalkedAbout(data?.data?.data || []);
      } catch (err) {
        console.error("Error fetching most talked about posts:", err);
      } finally {
        setLoadingMostTalkedAbout(false);
      }
    };

    TalkedAboutPosts();
  }, []);

  const fetchLatestPosts = async (pageNumber = 1, append = false) => {
    try {
      if (pageNumber === 1) {
        setLoadingLatestPosts(true);
      } else {
        setLoadingMore(true);
      }

      const res = await fetch(
        `${MyBaseUrl}/posts/latest?page=${pageNumber}`,
        buildFetchOptions(),
      );

      const data = await res.json();

      const newPosts = data?.data?.data || [];
      const meta = data?.data?.meta;

      if (append) {
        setLatestPosts((prev) => [...prev, ...newPosts]);
      } else {
        setLatestPosts(newPosts);
      }

      setLastPage(meta?.last_page);
    } catch (err) {
      console.error("Error fetching latest posts:", err);
    } finally {
      setLoadingLatestPosts(false);
      setLoadingMore(false);
    }
  };

  useEffect(() => {
    const loadInitialPages = async () => {
      let currentPage = 1;

      for (let i = 0; i < 1; i++) {
        await fetchLatestPosts(currentPage, i !== 0);
        currentPage++;
      }

      setPage(currentPage);
    };

    loadInitialPages();
  }, []);

  const loadMorePages = async () => {
    if (lastPage && page > lastPage) return;

    let currentPage = page;

    for (let i = 0; i < 1; i++) {
      if (lastPage && currentPage > lastPage) break;

      await fetchLatestPosts(currentPage, true);
      currentPage++;
    }

    setPage(currentPage);
  };

  const getDates = () => {
    const dates = [];
    const today = new Date();

    for (let i = -1; i <= 7; i++) {
      const d = new Date(today);

      d.setHours(12, 0, 0, 0);

      d.setDate(today.getDate() + i);

      dates.push({
        label:
          i === 0
            ? "Today"
            : d.toLocaleDateString("en-US", {
                weekday: "short",
              }),

        value: formatLocalDate(d),
      });
    }

    return dates;
  };

  const dates = getDates();

  const filteredMatches = featuredMatches?.filter((m) => {
    if (selectedLeague === "all") return true;

    return (
      m?.league?.name === selectedLeague ||
      m?.competition_name === selectedLeague
    );
  });

  const uniqueLeagues = [
    ...new Set(
      featuredMatches
        ?.map(
          (m) => m?.league?.name || m?.competition?.name || m?.competition_name,
        )
        .filter(Boolean),
    ),
  ];

  const [showMatches, setShowMatches] = useState(false);

  const myMargin = () => {};

  return (
    <>
      <Helmet>
        <title>
          FadaSports — Live Sports News, Scores, Analysis & Football Updates
        </title>

        <meta
          name="title"
          content="FadaSports — Live Sports News, Scores, Analysis & Football Updates"
        />

        <meta
          name="description"
          content="FadaSports delivers breaking sports news, live scores, football updates, expert analysis, transfer stories, match insights, and powerful fan-driven sports media experiences worldwide."
        />

        <meta
          name="keywords"
          content="FadaSports, football news, live scores, sports analysis, transfer news, football updates, sports media, match reports, football community, premier league news, champions league updates, sports platform"
        />

        <meta name="author" content="FadaSports" />

        <meta name="robots" content="index, follow" />

        <meta name="language" content="English" />

        <meta name="revisit-after" content="1 days" />

        <meta name="distribution" content="global" />

        <meta name="rating" content="general" />

        <link rel="canonical" href="https://fadasports.com/" />

        <meta property="og:type" content="website" />

        <meta property="og:url" content="https://fadasports.com/" />

        <meta
          property="og:title"
          content="FadaSports — Live Sports News, Scores, Analysis & Football Updates"
        />

        <meta
          property="og:description"
          content="The next generation sports media platform delivering breaking news, live scores, expert football analysis, transfer stories, and fan-powered sports experiences."
        />

        <meta
          property="og:image"
          content="https://fadasports.com/static/media/mobilelogo.d0257d49e02d3094cce0.png"
        />

        <meta property="og:site_name" content="FadaSports" />

        <meta property="og:locale" content="en_US" />

        <meta name="twitter:card" content="summary_large_image" />

        <meta name="twitter:url" content="https://fadasports.com/" />

        <meta
          name="twitter:title"
          content="FadaSports — Live Sports News, Scores, Analysis & Football Updates"
        />

        <meta
          name="twitter:description"
          content="Breaking sports stories, live football updates, match analysis, transfer insights, and the future of sports media."
        />

        <meta
          name="twitter:image"
          content="https://fadasports.com/static/media/mobilelogo.d0257d49e02d3094cce0.png"
        />

        <meta name="twitter:site" content="@FadaSports" />

        <meta name="viewport" content="width=device-width, initial-scale=1.0" />

        <meta name="theme-color" content="#000000" />

        <meta name="application-name" content="FadaSports" />

        <meta name="apple-mobile-web-app-capable" content="yes" />

        <meta
          name="apple-mobile-web-app-status-bar-style"
          content="black-translucent"
        />

        <meta name="apple-mobile-web-app-title" content="FadaSports" />

        <meta name="geo.region" content="NG" />

        <meta name="geo.placename" content="Nigeria" />

        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "SportsOrganization",
            name: "FadaSports",
            url: "https://fadasports.com",
            logo: { logo },
            description:
              "A next-generation global sports media platform delivering live sports news, football updates, scores, expert analysis, and immersive fan experiences.",
            sameAs: [
              "https://twitter.com/FadaSports",
              "https://instagram.com/FadaSports",
              "https://facebook.com/FadaSports",
            ],
          })}
        </script>
      </Helmet>

      <div className="homer">
        {loadingHome ? (
          <>
            <Skeleton dark={dark} count={6} />
            <Skeleton dark={dark} count={6} />
          </>
        ) : (
          <div className="HomeWrapper">
            <div className="mainsection">
              {/* <button
            onClick={() => {
              localStorage.removeItem("home_cache");
              localStorage.removeItem("home_cache_time");
              window.location.reload();
            }}
          >
            Refresh Data
          </button> */}

              {loadingMatches ? (
                <section className="matches">
                  <h1 className="title">Matches</h1>

                  <div className="match-list">
                    <nav>
                      {[1, 2, 3].map((_, i) => (
                        <div
                          key={i}
                          className="match-card skeleton skeleton-match"></div>
                      ))}
                    </nav>
                  </div>
                </section>
              ) : matches.length === 0 ? (
                <p></p>
              ) : (
                <>
                  <section className="matches">
                    <h1
                      className=""
                      style={
                        dark ? { color: "whitesmoke" } : { color: "#161819" }
                      }>
                      Matches{" "}
                      <img
                        src={match}
                        alt=""
                        onClick={() => setShowMatches((prev) => !prev)}
                        style={{
                          cursor: "pointer",
                          ...(dark ? { filter: "invert(1)" } : {}),
                        }}
                      />
                    </h1>

                    {showMatches && (
                      <div
                        className={`matches-collapse ${showMatches ? "open" : "closed"}`}>
                        <select
                          value={selectedLeague}
                          onChange={(e) => setSelectedLeague(e.target.value)}
                          style={
                            dark
                              ? {
                                  backgroundColor: "#1b1b1bff",
                                  boxShadow: "none",
                                  color: "white",
                                }
                              : {}
                          }>
                          <option value="all">All Leagues</option>

                          {uniqueLeagues?.map((l, i) => (
                            <option key={i} value={l}>
                              {l}
                            </option>
                          ))}
                        </select>

                        <span
                          style={{
                            display: "flex",
                            flexDirection: "row",
                            padding: "0 25px",
                            position: "relative",
                          }}>
                          <nav className="ror">
                            {dark ? (
                              <img
                                src={whiteArrow}
                                alt=""
                                onClick={scrollTabsLeft}
                                style={{
                                  transform: "rotate(180deg)",
                                  cursor: "pointer",
                                  scale: "0.5",
                                  marginTop: "-6px",
                                }}
                              />
                            ) : (
                              <img
                                src={blackArrow}
                                alt=""
                                onClick={scrollTabsLeft}
                                style={{ cursor: "pointer" }}
                              />
                            )}

                            {dark ? (
                              <img
                                src={whiteArrow}
                                style={{
                                  transform: "rotate(0deg)",
                                  cursor: "pointer",
                                  scale: "0.5",
                                  marginTop: "-6px",
                                }}
                                alt=""
                                className="right"
                                onClick={scrollTabsRight}
                              />
                            ) : (
                              <img
                                src={blackArrow}
                                style={{
                                  transform: "rotate(180deg)",
                                  cursor: "pointer",
                                }}
                                alt=""
                                className="right"
                                onClick={scrollTabsRight}
                              />
                            )}
                          </nav>

                          <div
                            ref={tabsRef}
                            className="tabs"
                            style={{
                              display: "flex",
                              overflowX: "auto",
                              gap: "8px",
                            }}>
                            {dates?.map((d, i) => {
                              const [year, month, day] = d.value.split("-");

                              const dateObj = new Date(year, month - 1, day);

                              const today = new Date();
                              const yesterday = new Date();
                              const tomorrow = new Date();

                              yesterday.setDate(today.getDate() - 1);
                              tomorrow.setDate(today.getDate() + 1);

                              const isToday =
                                dateObj.toDateString() === today.toDateString();

                              const isYesterday =
                                dateObj.toDateString() ===
                                yesterday.toDateString();

                              const isTomorrow =
                                dateObj.toDateString() ===
                                tomorrow.toDateString();

                              return (
                                <button
                                  key={i}
                                  className={
                                    selectedDate === d.value ? "active" : ""
                                  }
                                  onClick={() => setSelectedDate(d.value)}
                                  style={{
                                    minWidth: "90px",
                                    flexShrink: 0,

                                    ...(selectedDate === d.value
                                      ? {
                                          backgroundColor: "black",
                                          color: "#fff",
                                          boxShadow: "none",
                                        }
                                      : dark
                                        ? {
                                            backgroundColor: "#141414ff",
                                            color: "#fff",
                                          }
                                        : {}),
                                  }}>
                                  {isToday
                                    ? "Today"
                                    : isTomorrow
                                      ? "Tomorrow"
                                      : isYesterday
                                        ? "Yesterday"
                                        : dateObj.toLocaleDateString([], {
                                            weekday: "short",
                                            day: "2-digit",
                                            month: "short",
                                          })}
                                </button>
                              );
                            })}
                          </div>
                        </span>
                      </div>
                    )}

                    <div className="match-list">
                      <nav>
                        {loadingFeaturedMatches ? (
                          <>
                            {[1, 2, 3, 4].map((_, i) => (
                              <div
                                key={i}
                                className="match-card skeleton skeleton-match"
                                style={
                                  dark
                                    ? {
                                        backgroundColor: "#1b1b1bff",
                                        boxShadow: "none",
                                      }
                                    : {}
                                }></div>
                            ))}
                          </>
                        ) : filteredMatches?.length === 0 ? (
                          <p
                            style={{
                              color: dark ? "#fafafa" : "#161819",
                              textAlign: "center",
                              width: "100%",
                              padding: "0 20px",
                              opacity: "0.8",
                            }}>
                            No matches to show
                          </p>
                        ) : (
                          filteredMatches?.map((matchItem, i) => {
                            const fixtureId =
                              matchItem?.fixture?.id || matchItem?.id;

                            const homeTeam =
                              matchItem?.teams?.home || matchItem?.home_team;

                            const awayTeam =
                              matchItem?.teams?.away || matchItem?.away_team;

                            const leagueName =
                              matchItem?.league?.name ||
                              matchItem?.competition_name ||
                              "";

                            const matchDate =
                              matchItem?.fixture?.date || matchItem?.date;

                            const matchStatus =
                              matchItem?.fixture?.status?.short;

                            const matchstat = matchItem?.fixture?.status;

                            const homeGoals = matchItem?.goals?.home;

                            const awayGoals = matchItem?.goals?.away;

                            const elapsed =
                              matchItem?.fixture?.status?.elapsed || 0;

                            const isLive = elapsed > 0 && elapsed < 90;
                            return (
                              <Link
                                key={fixtureId || i}
                                to={`/matches/${createSlug(
                                  homeTeam?.name,
                                  awayTeam?.name,
                                )}/${fixtureId}`}
                                state={{ matchId: fixtureId }}
                                style={{ width: "100%" }}>
                                <div
                                  className="match-card"
                                  style={
                                    dark
                                      ? {
                                          backgroundColor: "#333333ff",
                                          boxShadow: "none",
                                        }
                                      : {
                                          backgroundColor: "white",
                                        }
                                  }>
                                  <span>
                                    <p
                                      className="round"
                                      style={
                                        dark
                                          ? {
                                              color: "#fafafaff",
                                              textAlign: "center",
                                            }
                                          : {
                                              color: "#161819",
                                              textAlign: "center",
                                            }
                                      }>
                                      {leagueName}
                                    </p>
                                  </span>

                                  <div className="teams">
                                    <div
                                      style={{
                                        display: "flex",
                                        flexDirection: "column",
                                        alignItems: "center",
                                        gap: "5px",
                                      }}>
                                      <img
                                        src={homeTeam?.logo}
                                        alt={homeTeam?.name}
                                      />

                                      <small
                                        style={
                                          dark
                                            ? { color: "#fafafaff" }
                                            : { color: "#161819" }
                                        }>
                                        {homeTeam?.code}
                                      </small>
                                    </div>

                                    <strong
                                      style={{
                                        display: "flex",
                                        flexDirection: "column",
                                        alignItems: "center",
                                        gap: "5px",
                                      }}>
                                      <p className="times">
                                        <span
                                          className={`date ${isLive ? "live-glow" : ""}`}
                                          style={
                                            matchstat?.long ===
                                              "Match Finished" &&
                                            matchstat?.short === "PEN"
                                              ? {
                                                  minWidth: "fit-content",
                                                  fontSize: "8px",
                                                }
                                              : isLive
                                                ? {
                                                    color: "#ff3b3b",
                                                    fontWeight: "800",
                                                  }
                                                : dark
                                                  ? { color: "#fafafaff" }
                                                  : { color: "#161819" }
                                          }>
                                          {(() => {
                                            const statusLong = matchstat?.long;
                                            const statusShort =
                                              matchstat?.short;

                                            const penaltyHome =
                                              matchItem?.score?.penalty?.home;

                                            const penaltyAway =
                                              matchItem?.score?.penalty?.away;

                                            const extraTimeHome =
                                              matchItem?.score?.extratime?.home;

                                            const extraTimeAway =
                                              matchItem?.score?.extratime?.away;

                                            const elapsedTime =
                                              matchstat?.elapsed || 0;

                                            if (
                                              [
                                                "1H",
                                                "2H",
                                                "HT",
                                                "ET",
                                                "BT",
                                                "P",
                                              ].includes(statusShort)
                                            ) {
                                              if (
                                                statusShort === "ET" ||
                                                elapsedTime > 90
                                              ) {
                                                return `ET ${elapsedTime}'`;
                                              }

                                              if (statusShort === "P") {
                                                return `PEN ${penaltyHome} - ${penaltyAway}`;
                                              }

                                              return `${elapsedTime}'`;
                                            }

                                            if (
                                              statusLong === "Match Finished" &&
                                              statusShort === "PEN"
                                            ) {
                                              return `PEN ${penaltyHome} - ${penaltyAway}`;
                                            }

                                            if (
                                              statusLong === "Match Finished" &&
                                              extraTimeHome !== null &&
                                              extraTimeAway !== null &&
                                              (extraTimeHome > 0 ||
                                                extraTimeAway > 0)
                                            ) {
                                              return "AET";
                                            }

                                            if (
                                              statusLong === "Match Finished"
                                            ) {
                                              return "FT";
                                            }

                                            return new Date(
                                              matchDate,
                                            ).toLocaleDateString([], {
                                              day: "2-digit",
                                              month: "short",
                                            });
                                          })()}
                                        </span>
                                      </p>

                                      {homeGoals !== null &&
                                      awayGoals !== null ? (
                                        <span
                                          style={{
                                            fontWeight: "700",
                                            fontSize: "18px",
                                            color: dark ? "#fff" : "#161819",
                                          }}>
                                          {homeGoals} - {awayGoals}
                                        </span>
                                      ) : (
                                        <>
                                          {!isLive && (
                                            <span
                                              className="hour"
                                              style={
                                                dark
                                                  ? { color: "#fafafaff" }
                                                  : { color: "#161819" }
                                              }>
                                              {(() => {
                                                const elapsedTime =
                                                  matchstat?.elapsed || 0;

                                                const statusShort =
                                                  matchstat?.short;

                                                const statusLong =
                                                  matchstat?.long;

                                                if (
                                                  statusLong ===
                                                  "Match Finished"
                                                ) {
                                                  return null;
                                                }

                                                if (
                                                  statusShort === "ET" ||
                                                  elapsedTime > 90
                                                ) {
                                                  return `${elapsedTime}'`;
                                                }

                                                if (
                                                  ["1H", "2H"].includes(
                                                    statusShort,
                                                  )
                                                ) {
                                                  return `${elapsedTime}'`;
                                                }

                                                if (
                                                  statusLong !==
                                                  "Match Finished"
                                                ) {
                                                  return new Date(
                                                    matchDate,
                                                  ).toLocaleTimeString([], {
                                                    hour: "2-digit",
                                                    minute: "2-digit",
                                                    hour12: false,
                                                  });
                                                }

                                                return null;
                                              })()}
                                            </span>
                                          )}
                                        </>
                                      )}

                                      <div
                                        style={{
                                          display: "flex",
                                          alignItems: "center",
                                          gap: "8px",
                                          marginTop: "5px",
                                        }}>
                                        {homeGoals !== null &&
                                        awayGoals !== null ? (
                                          <span
                                            className="hourd"
                                            style={
                                              dark
                                                ? { color: "#fafafaff" }
                                                : {
                                                    color: "#161819",
                                                    fontSize: "12px",
                                                  }
                                            }>
                                            {new Date(
                                              matchDate,
                                            ).toLocaleTimeString([], {
                                              hour: "2-digit",
                                              minute: "2-digit",
                                              hour12: false,
                                            })}
                                          </span>
                                        ) : (
                                          <span
                                            style={{
                                              fontWeight: "600",
                                              fontSize: "13px",
                                              color:
                                                matchStatus === "NS"
                                                  ? "#f59e0b"
                                                  : dark
                                                    ? "#fff"
                                                    : "#161819",
                                            }}>
                                            {/* {matchItem?.fixture?.status?.long ||
                                "Upcoming"} */}
                                          </span>
                                        )}
                                      </div>
                                    </strong>

                                    <div
                                      style={{
                                        display: "flex",
                                        flexDirection: "column",
                                        alignItems: "center",
                                        gap: "5px",
                                      }}>
                                      <img
                                        src={awayTeam?.logo}
                                        alt={awayTeam?.name}
                                      />

                                      <small
                                        style={
                                          dark
                                            ? { color: "#fafafaff" }
                                            : { color: "#161819" }
                                        }>
                                        {awayTeam?.code}
                                      </small>
                                    </div>
                                  </div>
                                </div>
                              </Link>
                            );
                          })
                        )}
                      </nav>
                    </div>
                  </section>
                </>
              )}

              {featuredPosts.length === 0 ? (
                <p></p>
              ) : (
                <>
                  {featuredPosts?.slice(0, 1)?.map((post, index) => (
                    <Link to={`/news/${post?.slug}`} key={index}>
                      <section
                        className="firstsection"
                        style={{
                          backgroundImage: `linear-gradient(#20202a44, #20202a4d), url(${post.image})`,
                        }}>
                        <div className="clubteam deep">
                          <h1 className="mobile-title">
                            {post?.title?.length > 60
                              ? post.title.slice(0, 60) + "..."
                              : post?.title}
                          </h1>
                          <h1 className="desktop-title">
                            {post?.title?.length > 200
                              ? post.title.slice(0, 200) + "..."
                              : post?.title}
                          </h1>
                        </div>
                      </section>
                    </Link>
                  ))}
                </>
              )}

              {loadingHome ? (
                <>
                  <section className="firstsection skeleton skeleton-first"></section>
                </>
              ) : featuredPosts.length === 0 ? (
                <p></p>
              ) : (
                <>
                  <section className="secondsection">
                    {featuredPosts?.slice(1, 3)?.map((post, index) => (
                      <Link to={`/news/${post?.slug}`} key={index}>
                        <div
                          style={
                            dark
                              ? { backgroundColor: "#616100ff" }
                              : { backgroundColor: "#FECD00" }
                          }>
                          <img src={post?.image} alt="" />
                          <p style={dark ? { color: "white" } : {}}>
                            {post?.title?.length > 45
                              ? post.title.slice(0, 45) + "..."
                              : post?.title}
                          </p>
                        </div>
                      </Link>
                    ))}
                  </section>
                </>
              )}

              {loadingVideos ? (
                <section className="thirdsection column">
                  <h1 className="title"></h1>
                  <div className="highlight">
                    <div className="slide1">
                      {[1, 2, 3].map((_, i) => (
                        <div
                          key={i}
                          className="imgdiv1 skeleton skeleton-video"></div>
                      ))}
                    </div>
                  </div>
                </section>
              ) : latestVideos.length === 0 ? (
                <p></p>
              ) : (
                <>
                  <section className="thirdsection column">
                    <h1
                      className="title"
                      style={
                        dark ? { color: "whitesmoke" } : { color: "#161819" }
                      }>
                      Video highlight
                    </h1>
                    <div className="highlight">
                      <div className="slide1">
                        {latestVideos?.map((videos, index) => (
                          <Link to={`/news/${videos?.slug}`} key={index}>
                            <div className="imgdiv1" key={index}>
                              <img src={videos?.image} alt="" />
                              <p>
                                {videos?.title?.length > 50
                                  ? videos.title.slice(0, 50) + "..."
                                  : videos?.title}
                              </p>
                            </div>
                          </Link>
                        ))}
                      </div>
                    </div>
                  </section>
                </>
              )}

              {loadingNews ? (
                <section className="fourthsection column">
                  <h1 className="title">Most Read News</h1>
                  <div className="cards1">
                    {[1, 2, 3, 4].map((_, i) => (
                      <div
                        key={i}
                        className="newscard skeleton skeleton-news"></div>
                    ))}
                  </div>
                </section>
              ) : popularNews.length === 0 ? (
                <p></p>
              ) : (
                <>
                  <section className="fourthsection column">
                    <h1
                      className="title"
                      style={
                        dark ? { color: "whitesmoke" } : { color: "#161819" }
                      }>
                      Most Read News
                    </h1>

                    <div
                      className="cards1"
                      style={
                        dark
                          ? { backgroundColor: "#134e79b9" }
                          : { backgroundColor: "#3451C7" }
                      }>
                      {popularNews.slice(0, 5)?.map((news, index) => (
                        <Link to={`/news/${news?.slug}`} key={index}>
                          <div
                            className="newscard"
                            style={
                              dark
                                ? {
                                    backgroundColor: "#161819e7",
                                    Color: "#fff",
                                  }
                                : { backgroundColor: "white", Color: "#161819" }
                            }>
                            <span style={getRankColor(index, dark)}>
                              {index + 1}
                            </span>
                            <p
                              style={
                                dark
                                  ? { color: "#e0e0e0ff" }
                                  : { color: "#161819" }
                              }>
                              {news?.title?.length > 85
                                ? news?.title.slice(0, 85) + "..."
                                : news?.title}
                            </p>
                            <p
                              style={
                                dark
                                  ? { color: "#e0e0e0ff" }
                                  : { color: "#161819" }
                              }>
                              {/* {news?.excerpt} */}
                            </p>
                            <button>Read more →</button>
                          </div>
                        </Link>
                      ))}
                    </div>
                  </section>
                </>
              )}

              {competitionloading ? (
                <section className="standings"></section>
              ) : competition.length === 0 ? (
                <></>
              ) : (
                <>
                  <section className="standings">
                    <div
                      className="competitionLeagues"
                      style={
                        dark
                          ? { backgroundColor: "#333333ff" }
                          : { backgroundColor: "white" }
                      }>
                      <ul
                        style={
                          dark
                            ? { backgroundColor: "#333333ff" }
                            : { backgroundColor: "white" }
                        }>
                        <li
                          style={
                            dark ? { color: "#fafafaff" } : { color: "#161819" }
                          }>
                          Leagues
                          <Link
                            to="/competition"
                            style={{ textDecoration: "none" }}>
                            <img
                              src={double}
                              alt=""
                              style={dark ? { filter: "invert(1)" } : {}}
                            />
                          </Link>
                        </li>
                      </ul>

                      {competitionloading ? (
                        <p>Loading...</p>
                      ) : competitionsError ? (
                        <p>Error: {competitionsError}</p>
                      ) : (
                        <nav>
                          {competition
                            ?.filter((comp) =>
                              [1, 2, 4, 39, 140, 135, 307].includes(
                                comp?.league?.id,
                              ),
                            )
                            ?.sort((a, b) => {
                              const order = [1, 2, 4, 39, 140, 135, 307];

                              return (
                                order.indexOf(a?.league?.id) -
                                order.indexOf(b?.league?.id)
                              );
                            })
                            ?.map((comp, index) => (
                              <img
                                key={index}
                                src={
                                  comp?.league?.id === 1
                                    ? worldCup
                                    : comp?.league?.logo
                                }
                                alt={comp?.league?.name}
                                onClick={() =>
                                  setSelectedLeagueId(comp?.league?.id)
                                }
                                style={{
                                  cursor: "pointer",
                                  border:
                                    selectedLeagueId === comp?.league?.id
                                      ? "2px solid red"
                                      : "2px solid transparent",
                                  borderRadius: "10px",
                                  padding: "5px",
                                }}
                              />
                            ))}
                        </nav>
                      )}
                    </div>

                    <div className="leagueStandings" id="leagueStandings">
                      {Loading ? (
                        <></>
                      ) : error ? (
                        <></>
                      ) : standings?.length === 0 ? (
                        <></>
                      ) : (
                        <nav
                          style={
                            dark
                              ? { backgroundColor: "#333333ff" }
                              : { backgroundColor: "white" }
                          }>
                          <Link
                            key={leagueInfo?.id}
                            to={`/competition/${leagueInfo?.name.replace(/\s+/g, "-").toLowerCase()}/${leagueInfo?.id}`}
                            style={{
                              textDecoration: "none",
                              color: "inherit",
                              display: "flex",
                              gap: "10px",
                              alignItems: "center",
                            }}>
                            <img
                              src={
                                leagueInfo?.id === 1
                                  ? worldCup
                                  : leagueInfo?.logo
                              }
                              alt={leagueInfo?.name}
                            />

                            <span>
                              <h1
                                style={
                                  dark
                                    ? { color: "#fafafaff" }
                                    : { color: "#161819" }
                                }>
                                {leagueInfo?.name}
                              </h1>
                              <p
                                style={
                                  dark
                                    ? { color: "#fafafaff" }
                                    : { color: "#161819" }
                                }>
                                {leagueInfo?.country}
                              </p>
                            </span>
                          </Link>
                        </nav>
                      )}

                      {Loading ? (
                        <div
                          className="spindiv"
                          style={{ padding: "0 30px", textAlign: "center" }}>
                          <p className="spinner"></p>
                          <p
                            style={{
                              marginTop: "10px",
                              color: dark ? "#fafafaff" : "#161819",
                            }}>
                            Loading standings...
                          </p>
                        </div>
                      ) : error ? (
                        <p
                          style={{
                            textAlign: "center",
                            padding: "20px",
                            color: dark ? "#fafafaff" : "#161819",
                          }}>
                          Error: {error}
                        </p>
                      ) : standings?.length === 0 ? (
                        <p
                          style={{
                            textAlign: "center",
                            padding: "0px",
                            color: dark ? "#fafafaff" : "#161819",
                          }}></p>
                      ) : (
                        <section>
                          <div className="tablehead">
                            <nav>
                              <h2>POS</h2>
                              <h2>TEAM</h2>
                            </nav>

                            <span>
                              <h2>P</h2>
                              <h2>W</h2>
                              <h2>D</h2>
                              <h2>L</h2>
                              <h2>GD</h2>
                              <h2>PTS</h2>
                            </span>
                          </div>

                          <section className="onlysection">
                            {standings?.slice(0, 5)?.map((team, index) => (
                              <div
                                key={team?.team?.id || index}
                                style={
                                  dark
                                    ? {
                                        backgroundColor: "#333333ff",
                                        color: "#fff",
                                        borderRadius: "30px",
                                        boxShadow:
                                          "1px 1px 30px rgba(0,0,0,0.39)",
                                        borderLeft: getBorderColor(
                                          team?.description,
                                        ),
                                      }
                                    : {
                                        backgroundColor: "white",
                                        borderLeft: getBorderColor(
                                          team?.description,
                                        ),
                                      }
                                }>
                                <nav>
                                  <h2
                                    style={
                                      dark
                                        ? { color: "#fafafaff" }
                                        : { color: "#161819" }
                                    }>
                                    {team?.rank}
                                  </h2>

                                  <h2>
                                    <img
                                      src={team?.team?.logo}
                                      width="20"
                                      alt=""
                                    />

                                    <Link
                                      key={index}
                                      to={`/teams/${createSlug(team?.team?.name)}-${team?.team?.id}`}>
                                      <span
                                        className="longName"
                                        style={
                                          dark
                                            ? { color: "#fafafaff" }
                                            : { color: "#161819" }
                                        }>
                                        {team?.team?.name}
                                      </span>
                                      <span
                                        className="codeName"
                                        style={
                                          dark
                                            ? { color: "#fafafaff" }
                                            : { color: "#161819" }
                                        }>
                                        {team?.team?.code}
                                      </span>
                                    </Link>
                                  </h2>
                                </nav>

                                <span>
                                  <h2
                                    style={
                                      dark
                                        ? { color: "#fafafaff" }
                                        : { color: "#161819" }
                                    }>
                                    {team?.all?.played}
                                  </h2>
                                  <h2
                                    style={
                                      dark
                                        ? { color: "#fafafaff" }
                                        : { color: "#161819" }
                                    }>
                                    {team?.all?.win}
                                  </h2>
                                  <h2
                                    style={
                                      dark
                                        ? { color: "#fafafaff" }
                                        : { color: "#161819" }
                                    }>
                                    {team?.all?.draw}
                                  </h2>
                                  <h2
                                    style={
                                      dark
                                        ? { color: "#fafafaff" }
                                        : { color: "#161819" }
                                    }>
                                    {team?.all?.lose}
                                  </h2>
                                  <h2
                                    style={
                                      dark
                                        ? { color: "#fafafaff" }
                                        : { color: "#161819" }
                                    }>
                                    {team?.goalsDiff}
                                  </h2>
                                  <h2
                                    style={
                                      dark
                                        ? { color: "#fafafaff" }
                                        : { color: "#161819" }
                                    }>
                                    {team?.points}
                                  </h2>
                                </span>
                              </div>
                            ))}
                          </section>
                        </section>
                      )}

                      {Loading ? (
                        <div></div>
                      ) : error ? (
                        <p></p>
                      ) : standings?.length === 0 ? (
                        <p
                          style={{
                            textAlign: "center",
                            padding: "20px",
                            color: dark ? "#fafafaff" : "#161819",
                          }}></p>
                      ) : (
                        <div className="btndiv">
                          <Link
                            key={leagueInfo?.id}
                            to={`/competition/${leagueInfo?.name.replace(/\s+/g, "-").toLowerCase()}/${leagueInfo?.id}/standings`}
                            style={{
                              textDecoration: "none",
                              color: "inherit",
                            }}>
                            <button className="view-all">
                              View All standings <img src={ro} alt="" />
                            </button>
                          </Link>
                        </div>
                      )}
                    </div>
                  </section>
                </>
              )}

              <section className="competitionsection">
                {loadingCompetitionPosts ? (
                  <nav>
                    {[1, 2].map((_, i) => (
                      <div key={i} className="skeleton skeleton-blog"></div>
                    ))}
                  </nav>
                ) : (
                  <>
                    <div className="compnewswrap">
                      <nav>
                        <span
                          style={{
                            display: "flex",
                            gap: "10px",
                            aliginItem: "center",
                          }}>
                          <img
                            src={
                              competitionPosts?.[0]?.competition?.id === 1
                                ? worldCup
                                : competitionPosts?.[0]?.competition?.logo
                            }
                          />
                          <h2
                            style={
                              dark
                                ? { color: "#e9e9e9ff" }
                                : { color: "#161819" }
                            }>
                            {competitionPosts?.[0]?.competition?.name}
                          </h2>
                        </span>
                        {competitionPosts.slice(0, 1).map((post, index) => (
                          <Link to={`/news/${post?.slug}`} key={index}>
                            <div>
                              <img src={post.image} alt="" />

                              <p
                                id="thep"
                                className="deep"
                                style={
                                  dark
                                    ? { color: "#fafafaff" }
                                    : { color: "#fafafaff" }
                                }>
                                {post?.title?.length > 60
                                  ? post.title.slice(0, 60) + "..."
                                  : post?.title}
                              </p>
                            </div>
                          </Link>
                        ))}
                      </nav>

                      {competitionPosts.slice(1, 5).map((post, index) => (
                        <Link to={`/news/${post?.slug}`} key={index}>
                          <div
                            className="posts"
                            style={
                              dark
                                ? { backgroundColor: "#333333ff" }
                                : { backgroundColor: "white" }
                            }>
                            <img src={post?.image || breaknews} alt="" />

                            <div>
                              <p
                                style={
                                  dark
                                    ? { color: "#e9e9e9ff" }
                                    : { color: "#161819" }
                                }>
                                {post?.title?.length > 80
                                  ? post.title.slice(0, 80) + "..."
                                  : post?.title}
                              </p>
                            </div>
                          </div>
                        </Link>
                      ))}

                      {competitionPosts.slice(0, 1).map((post) => {
                        const slug = createSlug(post?.competition?.name);

                        return (
                          <Link
                            key={post?.competition?.id}
                            to={`/competition/${slug}/${post?.competition?.id}/news`}
                            style={{
                              textDecoration: "none",
                              marginTop: "10px",
                            }}>
                            <button
                              className={`view-all-btn ${dark ? "dark" : ""}`}>
                              view all <img src={ro} alt="" />
                            </button>
                          </Link>
                        );
                      })}
                    </div>
                  </>
                )}
              </section>

              <section className="fifthsection column">
                {featuredMatches.length !== 0 && (
                  <h1
                    className="title"
                    style={
                      dark ? { color: "whitesmoke" } : { color: "#161819" }
                    }>
                    Featured match
                  </h1>
                )}

                {featuredMatches?.slice(0, 1)?.map((match, index) => (
                  <Link
                    key={index}
                    to={`/matches/${createSlug(
                      match?.teams?.home?.name,
                      match?.teams?.away?.name,
                    )}/${match?.fixture?.id}`}
                    state={{ matchId: match?.fixture?.id }}
                    style={{ minWidth: "100%" }}>
                    <div
                      key={index}
                      style={{
                        backgroundColor: dark ? "" : "#fff",
                        padding: "20px",
                        // boxShadow: dark
                        //   ? "none"
                        //   : "0 1px 3px rgba(0, 0, 0, 0.08)",
                      }}>
                      <span>
                        <h2>
                          <strong
                            // style={{
                            //   color: getTeamColor(match?.teams?.home?.id)
                            //   color: "white"
                            //  }}
                            style={
                              dark
                                ? { color: "whitesmoke" }
                                : { color: "#161819" }
                            }
                            className="ss">
                            {match?.teams?.home?.name}
                          </strong>
                          <strong
                            // style={{
                            //   color: getTeamColor(match?.teams?.away?.id)
                            //   color: "white"
                            //   }}
                            style={
                              dark
                                ? { color: "whitesmoke" }
                                : { color: "#161819" }
                            }>
                            {match?.teams?.away?.name}
                          </strong>
                        </h2>

                        <h3
                          style={
                            dark
                              ? { color: "whitesmoke" }
                              : { color: "#161819" }
                          }>
                          {match?.league?.name},{" "}
                          <b style={{ textTransform: "uppercase" }}>
                            {match?.fixture?.venue?.name}
                          </b>
                        </h3>

                        <h4
                          style={
                            dark
                              ? { color: "whitesmoke" }
                              : { color: "#161819" }
                          }>
                          {new Date(match?.fixture?.date).toLocaleDateString(
                            [],
                            {
                              day: "2-digit",
                              month: "short",
                              year: "numeric",
                            },
                          )}{" "}
                          •{" "}
                          {new Date(match?.fixture?.date).toLocaleTimeString(
                            [],
                            {
                              hour: "2-digit",
                              minute: "2-digit",
                              hour12: false,
                            },
                          )}
                        </h4>
                      </span>

                      <nav>
                        <Link
                          to={`/teams/${match?.teams?.home?.name
                            ?.replace(/\s+/g, "")
                            .toLowerCase()}-${match?.teams?.home?.id}`}
                          style={{ textDecoration: "none", color: "inherit" }}>
                          <img src={match?.teams?.home?.logo} alt="home team" />
                        </Link>
                        <b
                          style={
                            dark
                              ? { color: "whitesmoke" }
                              : { color: "#161819" }
                          }>
                          VS
                        </b>

                        <Link
                          to={`/teams/${match?.teams?.away?.name
                            ?.replace(/\s+/g, "")
                            .toLowerCase()}-${match?.teams?.away?.id}`}
                          style={{ textDecoration: "none", color: "inherit" }}>
                          <img src={match?.teams?.away?.logo} alt="away team" />
                        </Link>
                      </nav>
                    </div>
                  </Link>
                ))}
              </section>
              {/* )
              }  */}

              {loadingPlayers ? (
                <section className="sixthsection column">
                  <div className="highlight">
                    <div className="slide1">
                      {[1, 2, 3].map((_, i) => (
                        <div
                          key={i}
                          className="imgdiv1 skeleton skeleton-player"></div>
                      ))}
                    </div>
                  </div>
                </section>
              ) : trendingPlayers.length === 0 ? (
                <p></p>
              ) : (
                <section className="sixthsection column">
                  <h1
                    className="title"
                    style={
                      dark ? { color: "whitesmoke" } : { color: "#161819" }
                    }>
                    Trending Players
                  </h1>
                  <div className="highlight">
                    <div className="slide1">
                      {trendingPlayers?.map((players, index) => (
                        <div className="imgdiv1" key={index}>
                          <img src={players.photo} alt="" className="behind" />

                          <p>
                            {(() => {
                              const team =
                                players?.statistics?.team ||
                                players?.metadata?.team ||
                                players?.team;

                              if (!team) return null;

                              return (
                                <Link
                                  to={`/teams/${team?.name
                                    ?.replace(/\s+/g, "")
                                    .toLowerCase()}-${team?.id}`}
                                  style={{
                                    textDecoration: "none",
                                    color: "inherit",
                                  }}>
                                  <img
                                    src={team?.logo}
                                    alt={team?.name}
                                    className="mylogos"
                                  />
                                </Link>
                              );
                            })()}
                            <strong>
                              {players?.metadata?.player?.name || players?.name}
                            </strong>

                            <Link
                              to={`/players/${players?.name
                                ?.trim()
                                .replace(/[^a-zA-Z.\s]/g, "")
                                .replace(/\s+/g, "-")
                                .toLowerCase()}-${players?.api_id}`}
                              state={{ player: players }}
                              key={players?.id}>
                              <button>View Player</button>
                            </Link>
                          </p>
                        </div>
                      ))}
                    </div>
                  </div>
                </section>
              )}

              {loadingBreakingNews ? (
                <></>
              ) : // <section className="seventhsection">
              //   <div className="skeleton skeleton-breaking"></div>
              // </section>
              breakingnews.length === 0 ? (
                <p></p>
              ) : (
                <section
                  className="seventhsection"
                  style={
                    dark
                      ? {
                          backgroundColor: "#ca10107c",
                          color: "rgba(231, 231, 231, 1)",
                        }
                      : { backgroundColor: "#FE0000", color: "#161819" }
                  }>
                  <h1>Breaking News</h1>
                  {breakingnews.slice(0, 1)?.map((news, index) => (
                    <div>
                      <div className="imgdiv2">
                        <img src={news.image} alt="" />
                      </div>
                      <nav>
                        <h2
                          style={
                            dark
                              ? { color: "#fafafaff" }
                              : { color: "#fafafaff" }
                          }>
                          {news?.title?.length > 50
                            ? news?.title.slice(0, 50) + "..."
                            : news?.title}
                        </h2>
                        <p
                          style={
                            dark
                              ? { color: "#fafafaff" }
                              : { color: "#fafafaff" }
                          }>
                          {news?.excerpt?.length > 30
                            ? news?.excerpt.slice(0, 30) + "..."
                            : news?.excerpt}{" "}
                        </p>

                        <Link to={`/news/${news?.slug}`} key={index}>
                          <button
                            style={
                              dark
                                ? {
                                    backgroundColor: "#cfcfcfff",
                                    color: "rgba(107, 31, 31, 1)",
                                  }
                                : { backgroundColor: "white", color: "" }
                            }>
                            View more details
                          </button>
                        </Link>
                      </nav>
                    </div>
                  ))}
                </section>
              )}

              {mostTalkedAbout?.length <= 0 ? (
                <></>
              ) : (
                <>
                  <section
                    className="eightsection"
                    style={
                      dark
                        ? { backgroundColor: "#333" }
                        : { backgroundColor: "white" }
                    }>
                    <div
                      className={
                        `"subsection-header"` + (dark ? " dark-subsection" : "")
                      }>
                      {mostTalkedAbout?.length >= 0 && (
                        <div>
                          <h2 className="title">Most talked about</h2>
                        </div>
                      )}
                    </div>

                    <div
                      className={
                        `"subsection-content"` +
                        (dark ? " dark-subsection" : "")
                      }>
                      <>
                        {mostTalkedAbout?.slice(0, 1)?.map((item, index) => (
                          <Link
                            key={item?.id || index}
                            to={`/news/${item?.slug}`}
                            state={{ post: item }}
                            style={{
                              textDecoration: "none",
                              color: "inherit",
                            }}>
                            <div className="sub-card1">
                              <img src={item?.image} alt="" />

                              <div className="deep con">
                                <h3>
                                  {item?.title?.slice(0, 50)}
                                  {item?.title?.length > 50 ? "..." : ""}
                                </h3>

                                {/* <p>
                                      {item?.excerpt?.slice(0, 90)}
                                      {item?.excerpt?.length > 90 ? "..." : ""}
                                    </p> */}

                                {/* <small>
                                      👁 {item?.views_count || 0} views
                                    </small> */}
                              </div>
                            </div>
                          </Link>
                        ))}
                        {mostTalkedAbout?.slice(1, 10)?.map((item, index) => (
                          <Link
                            key={item?.id || index}
                            to={`/news/${item?.slug}`}
                            state={{ post: item }}
                            style={{
                              textDecoration: "none",
                              color: "inherit",
                            }}>
                            <div className="sub-card">
                              <img src={item?.image} alt="" />

                              <div>
                                <h3>
                                  {item?.title?.slice(0, 70)}
                                  {item?.title?.length > 70 ? "..." : ""}
                                </h3>
                              </div>
                            </div>
                          </Link>
                        ))}
                      </>
                    </div>
                  </section>
                </>
              )}

              <section className="ninesection">
                {latestPosts.length !== 0 && (
                  <h1
                    className="title"
                    style={
                      dark ? { color: "whitesmoke" } : { color: "#161819" }
                    }>
                    Latest News
                  </h1>
                )}

                {loadingLatestPosts ? (
                  <nav>
                    {[1, 2].map((_, i) => (
                      <div key={i} className="skeleton skeleton-blog"></div>
                    ))}
                  </nav>
                ) : latestPosts.length === 0 ? (
                  <p></p>
                ) : (
                  <>
                    <nav>
                      {latestPosts.slice(0, 1).map((post, index) => (
                        <Link to={`/news/${post?.slug}`} key={index}>
                          <div>
                            <img src={post?.image} alt="" />
                            <p
                              className="deep"
                              style={
                                dark
                                  ? { color: "#fafafaff" }
                                  : { color: "#161819" }
                              }>
                              {post?.title?.length > 60
                                ? post.title.slice(0, 60) + "..."
                                : post?.title}
                            </p>
                          </div>
                        </Link>
                      ))}
                    </nav>

                    {latestPosts.slice(1).map((post, index) => (
                      <Link to={`/news/${post?.slug}`} key={index}>
                        <div
                          className="posts"
                          style={
                            dark
                              ? { backgroundColor: "#333333ff" }
                              : { backgroundColor: "white" }
                          }>
                          <img src={post?.image} alt="" />
                          <div>
                            <p
                              style={
                                dark
                                  ? { color: "#e9e9e9ff" }
                                  : { color: "#161819" }
                              }>
                              {post?.title?.length > 70
                                ? post.title.slice(0, 70) + "..."
                                : post?.title}
                            </p>

                            <span
                              className="meta"
                              style={
                                dark
                                  ? { color: "#e9e9e9ff" }
                                  : { color: "#3e3f3f" }
                              }>
                              {post?.type} •{" "}
                              {new Date(
                                post?.published_at,
                              ).toLocaleDateString()}
                            </span>
                          </div>
                        </div>
                      </Link>
                    ))}
                  </>
                )}
                {lastPage && page <= lastPage && (
                  <div style={{ textAlign: "center", marginTop: "0px" }}>
                    <Link to="/latest-news">
                      <button
                        disabled={loadingMore}
                        className={`view-all-btn ${dark ? "dark" : ""}`}>
                        {loadingMore ? "Loading..." : "See all latest news"}
                      </button>
                    </Link>
                  </div>
                )}
              </section>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default Home;
